export default __webpack_public_path__ + "static/media/float-card.88e957ea.png";